import { reduxKey } from '../constants';
import { createAction } from 'redux-actions';
export const fetchGifs = createAction(`${reduxKey}.EXTENSION_GIF_FETCH`, (q, pg)=>({
        q,
        pg
    }));
export const fetchGifsSuccess = createAction(`${reduxKey}.EXTENSION_GIF_FETCH_SUCCESS`, (gifs)=>({
        gifs
    }));
export const fetchGifsFailure = createAction(`${reduxKey}.EXTENSION_GIF_FETCH_FAILURE`, ()=>({}));

//# sourceMappingURL=extension-gif.js.map